/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { DropdownItem } from '../DropdownItem';
import { DropdownSectionProps } from './DropdownSection.props';

/**
 * SDS Dropdown section.
 */
export const DropdownSection = (props: DropdownSectionProps): JSX.Element => {
  const { accessibleDropdownItemProps, closeDropdown, dropdownSection, firstItemIndex } = props;

  const getHeading = (): JSX.Element => {
    if (dropdownSection.heading) {
      return (
        <div className="sds-dropdown-section__heading">
          <span>{dropdownSection.heading}</span>
        </div>
      );
    }

    return <></>;
  };

  const getDropdownItems = (): Array<JSX.Element> => {
    return dropdownSection.items.map((item, itemIndex): JSX.Element => {
      const dropdownIndex = firstItemIndex + itemIndex;
      const accessibleProps = accessibleDropdownItemProps[dropdownIndex];
      return (
        <React.Fragment key={item.key}>
          <DropdownItem accessibleProps={accessibleProps} closeDropdown={closeDropdown} dropdownItem={item} />
        </React.Fragment>
      );
    });
  };

  const getSectionContent = (): JSX.Element => {
    if (dropdownSection.customContent) {
      return dropdownSection.customContent;
    }

    return (
      <ul className="sds-dropdown-list" role="none">
        {getDropdownItems()}
      </ul>
    );
  };

  return (
    <section className="sds-dropdown-section">
      {getHeading()}
      {getSectionContent()}
    </section>
  );
};
